module.exports = __webpack_public_path__ + "static/media/muncipal_tax_2.8aea3573.svg";